import React from 'react'
import styled from 'styled-components'
import Offscreen from 'react-offscreen'
import Description from '../Description'
import TotalCosts from './TotalCosts'
import AverageCosts from './AverageCosts'
import TotalCostsChart from './TotalCosts/Chart'
import AverageAnnualCostsChart from './AverageCosts/AnnualChart'
import AverageMonthlyCostsChart from './AverageCosts/MonthlyChart'
import Buttons from './Buttons'

const ChartsContainer = styled.div`
  width: 600px;
  height: ${props => props.small ? '350px' : '600px'};
  background-color: ${props => props.theme.colors.white};
`

const Container = styled.div`
  position: absolute;
  overflow: hidden;
  width: 0;
  height: 0;
`

export default (props) => (
  <>
    <Description heading='Results: Cost breakdown of raising a child'>
      Review your results and the cost breakdown of the monthly and annual costs you can expect to be paying.
    </Description>
    <TotalCosts {...props} />
    <AverageCosts {...props} />
    <Buttons {...props} />

    <Container>
      <Offscreen>
        <ChartsContainer id='export-total-costs-chart'>
          <TotalCostsChart {...props} />
        </ChartsContainer>
        <ChartsContainer small id='export-average-annual-costs-chart'>
          <AverageAnnualCostsChart {...props} />
        </ChartsContainer>
        <ChartsContainer small id='export-average-monthly-costs-chart'>
          <AverageMonthlyCostsChart {...props} />
        </ChartsContainer>
      </Offscreen>
    </Container>
  </>
)
